/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { seguridad } from '../../conexiones';
import IUsuarioPersona from '@infotrack/presentacion-modulosbase/modelos/seguridad/usuario/entidades/IUsuarioPersona';

export default class ModeloUsuario {
    public consultarListaUsuarioPersonaEmpresaPerfil(idEmpresa: string, idPerfil: string) {
        return manejadorRest<IRespuesta<IUsuarioPersona>>(() =>
            seguridad.get(`Usuario/ListaUsuarioPersonaEmpresaPerfil/${idEmpresa}/${idPerfil}`)
        );
    }
}
